import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import App from './App';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import * as Sentry from '@sentry/browser';
import 'dayjs/locale/zh-cn';
import { Empty } from 'antd';

Empty.PRESENTED_IMAGE_SIMPLE = process.env.PUBLIC_URL + '/empty.svg';

dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
const store = configureStore();
Sentry.init({
  dsn: 'https://4cafa657e00e47ac964abf72be58783d@sentry.olbai.com/3',
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
